module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/glyphicons-halflings-regular.woff
// module id = RxqL
// module chunks = 0